import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home.vue'
import Launch from '@/views/Launch.vue'
import store from "@/store"

Vue.use(Router)
export const constantRouterMap = [
    {
        path: '/',
        redirect: '/launch'
    },
    {
        path: '/launch',
        component: Launch
    }
]

export const dynamicRouterMap = [
    {
        path: '/home',
        component: Home,
        children: []
    },
    {
        path: '*',
        component: () => import( './components/NoJurisdiction.vue')
    }
]

export const asyncRouterMap = [
    {
        path: 'liveRoom_list/all',
        meta: {
            title: "router.liveRoom_list.all",
            icon: "md-desktop",
            nameKey:"liveRoomList"
        },
        component: () => import('./views/Production/liveRoomManagement/liveRoomList/All.vue')
        // beforeEnter: function(to, from,next){
        //     console.log("route enter ", to, from);
        //     next();
        // }
    },
    {
        path: 'liveRoom_list/slowlive',
        meta: {
            title: "慢直播间列表",
            icon: "md-desktop",
            nameKey:"liveRoomList"
        },
        component: () => import('./views/Production/liveRoomManagement/liveRoomList/SlowLive.vue')
    },
    {
        path: 'liveRoom_list/detail/edit/:id',
        meta: {
            title: "router.liveRoom_list.edit",
            icon: "md-desktop",
            nameKey: "editLiveRoom"
        },
        props: true,
        component: () => import('./views/Production/liveRoomManagement/liveRoomList/Edit.vue')
    },
    {
        path: 'liveRoom_list/detail/editslowlive/:id',
        meta: {
            title: "router.liveRoom_list.edit",
            icon: "md-desktop",
            nameKey: "editLiveRoom"
        },
        props: true,
        component: () => import('./views/Production/liveRoomManagement/liveRoomList/SlowLiveEdit.vue')
    },
    {
        path: 'liveRoom_list/detail/:id/:selectType',
        meta: {
            title: "router.liveRoom_list.detail",
            icon: "md-desktop",
            nameKey: "liveRoomDetail"
        },
        props: true,
        component: () => import('./views/Production/liveRoomManagement/liveRoomList/Detail.vue')
    },
    {
        path: 'liveRoom_list/detailslowlive/:id/:selectType',
        meta: {
            title: "router.liveRoom_list.detail",
            icon: "md-desktop",
            nameKey: "liveRoomDetail"
        },
        props: true,
        component: () => import('./views/Production/liveRoomManagement/liveRoomList/Detail.vue')
    },
    {
        path: 'liveRoom_list/detail/videoRef/:roomId/:userId',
        meta: {
            title: "router.liveRoom_list.videoRef",
            icon: "md-bookmarks",
            nameKey: "videoRef"
        },
        props: true,
        component: () => import('./views/Production/liveRoomManagement/liveRoomList/VideoRef.vue')
    },
    {
        path: 'liveRoom_list/detailslowlive/videoRef/:roomId/:userId',
        meta: {
            title: "router.liveRoom_list.videoRef",
            icon: "md-bookmarks",
            nameKey: "videoRef"
        },
        props: true,
        component: () => import('./views/Production/liveRoomManagement/liveRoomList/VideoRef.vue')
    },
    {
        path: 'live_category/all',
        meta: {
            title: "直播间专题列表",
            icon: "md-desktop",
            nameKey: "liveRoomCategory"
        },
        component: () => import('./views/Production/liveRoomManagement/liveCategory/All.vue')
    },
    {
        path: 'live_category/detail/:id',
        meta: {
            title: "直播间专题详情",
            icon: "md-desktop",
            nameKey: "liveRoomCategoryRef"
        },
        props: true,
        component: () => import('./views/Production/liveRoomManagement/liveCategory/Detail.vue')
    },
    {
        path: 'live_category/detail/room/:id/:selectType',
        meta: {
            title: "router.liveRoom_list.detail",
            icon: "md-desktop",
            nameKey: "liveRoomDetail"
        },
        props: true,
        component: () => import('./views/Production/liveRoomManagement/liveRoomList/Detail.vue')
    },
    {
        path: 'live_category/create',
        meta: {
            title: "新增直播间专题",
            icon: "md-desktop",
            nameKey: "liveRoomCategoryRef"
        },
        props: {
            id: 0,
        },
        component: () => import('./views/Production/liveRoomManagement/liveCategory/Edit.vue')
    },
    {
        path: 'live_category/edit/:id',
        meta: {
            title: "编辑直播间专题",
            icon: "md-desktop",
            nameKey: "liveRoomCategoryRef"
        },
        props: true,
        component: () => import('./views/Production/liveRoomManagement/liveCategory/Edit.vue')
    },
    {
        path: 'related_report/All',
        meta: {
            title: "router.related_report.all",
            icon: "md-desktop",
            nameKey: "correlativeReport"
        },
        component: () => import('./views/Production/liveRoomManagement/relatedReport/All.vue')
    },
    {
        path: 'related_report/detail/:id',
        meta: {
            title: "router.related_report.detail",
            icon: "md-desktop",
            nameKey: ["addCorrelativeReport", "editCorrelativeReport"]
        },
        props: true,
        component: () => import('./views/Production/liveRoomManagement/relatedReport/Detail.vue')
    },
    {
        path: 'related_report/detailRefRoom/:roomId',
        meta: {
            title: "router.related_report.detail",
            icon: "md-desktop",
            nameKey: ["addCorrelativeReport", "editCorrelativeReport"]
        },
        props: true,
        component: () => import('./views/Production/liveRoomManagement/relatedReport/DetailRefRoom.vue')
    },
    {
        path: 'live_record/All',
        meta: {
            title: "router.live_record",
            icon: "md-desktop",
            nameKey: "liveTask"
        },
        component: () => import('./views/Production/liveRoomManagement/liveRecord/All.vue')
    },
    {
        path: 'material_management/all',
        meta: {
            title: "router.material_management.all",
            icon: "md-bookmarks",
            nameKey: "materialInfo",
            hideInGZTV: true
        },
        component: () => import( './views/Production/MaterialManagement/All.vue')
    },
    {
        path: 'material_management/material/all/:id/:topicUid',
        meta: {
            title: "router.material_management.material",
            icon: "md-bookmarks",
            nameKey: "editMaterialInfo",
            hideInGZTV: true
        },
        props: true,
        component: () => import( './views/Production/MaterialManagement/Material/All.vue')
    },
    {
        path: 'watermark_management/all',
        meta: {
            title: "router.watermark_management.all",
            icon: "md-water",
            nameKey: "watermark"
        },
        component: () => import( './views/Production/WatermarkManagement/All.vue')
    },
    {
        path: 'watermark_management/detail/:id',
        meta: {
            title: "router.watermark_management.detail",
            icon: "md-water",
            nameKey: ["addWatermark","editWatermark"]
        },
        props: true,
        component: () => import('./views/Production/WatermarkManagement/Detail.vue')
    },
    {
        path: 'director/All/:type?',
        meta: {
            title: route => {
                const type = route.params.type || "all";
                return `router.director.${type}`;
            },
            icon: "logo-youtube",
            nameKey: "director"
        },
        props: true,
        component: () => import('./views/Production/directorManagement/director/All.vue')
    },
    {
        path: 'department_template/All',
        meta: {
            title: "router.department_template.all",
            icon: "logo-youtube",
            nameKey: "selectGlobalEffectGroupTemplate"
        },
        component: () => import('./views/Production/directorManagement/departmentTemplate/All.vue')
    },
    {
        path: 'department_template/detail/:id/:ownerId',
        meta: {
            title: "router.department_template.detail",
            icon: "logo-youtube",
            nameKey: ["addGlobalEffectGroupTemplate", "editGlobalEffectGroupTemplate"],
            isDepartmentAdmin: true, // 必须是部门管理员才能新增和修改
            isSuperAdmin: true   //如果是超级管理员，包括了部门管理员的权限，优先判断
        },
        props: true,
        component: () => import('./views/Production/directorManagement/departmentTemplate/Detail.vue')
    },
    {
        path: 'department_template/detail/:id/:ownerId/:copy',
        meta: {
            title: "router.department_template.detailCopy",
            icon: "logo-youtube",
            nameKey: "copyGlobalEffectGroupTemplate",
            isDepartmentAdmin: true, // 必须是部门管理员才能新增和修改
            isSuperAdmin: true   //如果是超级管理员，包括了部门管理员的权限，优先判断
        },
        props: true,
        component: () => import('./views/Production/directorManagement/departmentTemplate/Detail.vue')
    },
    {
        path: 'material_template/All',
        meta: {
            title: "router.material_template.all",
            icon: "logo-youtube",
            nameKey: "groupMaterialTemplate"
        },
        component: () => import('./views/Production/directorManagement/materialTemplate/All.vue')
    },
    {
        path: 'material_template/detail/:id/:ownerId',
        meta: {
            title: "router.material_template.detail",
            icon: "logo-youtube",
            nameKey: ["addEffectGroupTemplate", "editEffectGroupTemplate"]
        },
        props: true,
        component: () => import('./views/Production/directorManagement/materialTemplate/Detail.vue')
    },
    {
        path: 'material_template/detail/:id/:ownerId/:copy',
        meta: {
            title: "router.material_template.detailCopy",
            icon: "logo-youtube",
            nameKey: "copyEffectGroupTemplate"
        },
        props: true,
        component: () => import('./views/Production/directorManagement/materialTemplate/Detail.vue')
    },
    {
        path: 'cloud_editor/All',
        meta: {
            title: "router.cloud_editor.all",
            icon: "ios-cut",
            nameKey: "cloudEditor",
            hideInGZTV: true
        },
        component: () => import('./views/Production/cloudEditor/All.vue')
    },
    {
        path: 'cloud_editor/output_task/:id',
        meta: {
            title: "router.cloud_editor.outputTask",
            icon: "ios-cut",
            nameKey: "outCloudEditor",
            hideInGZTV: true
        },
        props: true,
        component: () => import('./views/Production/cloudEditor/OutputTask.vue')
    },
    {
        path: 'real_editor/All',
        meta: {
            title: "router.real_editor",
            icon: "md-cut",
            nameKey: "realEditor",
            hideInGZTV: true
        },
        component: () => import('./views/Production/realEditor/All.vue')
    },
    {
        path: 'virtual_office/All',
        meta: {
            title: "router.virtual_office",
            icon: "md-podium",
            nameKey: "virtualOfficeList",
            hideInGZTV: true
        },
        component: () => import('./views/Production/virtualOfficeManagement/virtualOffice/All.vue')
    },
    {
        path: 'virtual_office_template/All',
        meta: {
            title: "router.virtual_office_template.all",
            icon: "md-podium",
            nameKey: "virtualOfficeTemplate",
            hideInGZTV: true
        },
        component: () => import('./views/Production/virtualOfficeManagement/virtualOfficeTemplate/All.vue')
    },
    {
        path: 'virtual_office_template/detail/:id',
        meta: {
            title: "router.virtual_office_template.detail",
            icon: "md-podium",
            nameKey: ["addTemplate", "editTemplate"],
            hideInGZTV: true
        },
        props: true,
        component: () => import('./views/Production/virtualOfficeManagement/virtualOfficeTemplate/Detail.vue')
    },
    {
        path: 'virtual_office_template/management/:id/:ownerId',
        meta: {
            title: "router.virtual_office_template.management",
            icon: "md-podium",
            nameKey: "virtualTemplate",
            hideInGZTV: true
        },
        props: true,
        component: () => import('./views/Production/virtualOfficeManagement/virtualOfficeTemplate/Management.vue')
    },
    {
        path: 'hard_encoder/All',
        meta: {
            title: "router.hard_encoder.all",
            icon: "md-construct",
            nameKey: "hardEncoder",
            hideInGZTV: true
        },
        component: () => import('./views/Production/hardEncoder/All.vue')
    },
    {
        path: 'hard_encoder/detail/:id',
        meta: {
            title: "router.hard_encoder.detail",
            icon: "md-construct",
            nameKey: "hardEncoderEdit",
            hideInGZTV: true
        },
        props: true,
        component: () => import('./views/Production/hardEncoder/Detail.vue')
    }
]

export default new Router({
     routes: constantRouterMap
})